import React, { useState } from 'react';
import axios from 'axios';
import {
  Modal,
  Text,
  Title,
  Stack,
  TextInput,
  Textarea,
  Button,
  Alert
} from '@mantine/core';

// Shared beta-request modal — the only account-creation entry point right
// now (see backend/routes/auth.js's POST /auth/beta-signup). Used by both
// LandingPage.js and LoginPage.js, which used to each carry their own
// byte-for-byte-identical copy of this modal.
const BetaSignupModal = ({ opened, onClose }) => {
  const [form, setForm] = useState({ email: '', name: '', reason: '' });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleClose = () => {
    onClose();
    setError('');
    setSuccess(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      await axios.post('/auth/beta-signup', form);

      setSuccess(true);
      setTimeout(() => {
        handleClose();
        setForm({ email: '', name: '', reason: '' });
      }, 4000);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to submit request. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      opened={opened}
      onClose={handleClose}
      title={<Text size="xl" fw={700}>🚀 Join the Beta Waitlist</Text>}
      size="md"
      centered
    >
      {success ? (
        <Stack align="center" gap="md" py="xl">
          <Text size="80px">🎉</Text>
          <Title order={2} ta="center">Thanks for your interest!</Title>
          <Text ta="center" c="dimmed">
            Your request is being reviewed — we'll email you at {form.email} once your account is approved.
          </Text>
        </Stack>
      ) : (
        <form onSubmit={handleSubmit}>
          <Stack gap="md">
            {error && (
              <Alert color="red" variant="light">
                {error}
              </Alert>
            )}

            <TextInput
              label="Email Address"
              placeholder="your@email.com"
              required
              type="email"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
            />

            <TextInput
              label="Full Name"
              placeholder="Your name"
              required
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
            />

            <Textarea
              label="Why are you interested? (Optional)"
              placeholder="Tell us what excites you about GiftPersona..."
              rows={3}
              value={form.reason}
              onChange={(e) => setForm({ ...form, reason: e.target.value })}
            />

            <Button
              type="submit"
              fullWidth
              size="lg"
              variant="gradient"
              gradient={{ from: 'grape', to: 'pink' }}
              loading={loading}
            >
              Join Waitlist
            </Button>

            <Text size="xs" c="dimmed" ta="center">
              By joining, you'll receive email updates about GiftPersona. Unsubscribe anytime.
            </Text>
          </Stack>
        </form>
      )}
    </Modal>
  );
};

export default BetaSignupModal;
